import Flickity from 'flickity';

const selectors = {
  tabsSection: '.tabs-section',
  tabsCarousel: '.tabs-section__block',
  secondTabCarousel: '.tabs-section__block-second',
  blockSlider: '.tabs-section__block-slider',
  prevButton: '.tabs-section-prev-btn',
  nextButton: '.tabs-section-next-btn',
  firstTabBtn: '#tabBtnFirst',
  secondTabBtn: '#tabBtnSecond',
  tabFirst: '.tabs-section__block-first',
  tabSecond: '.tabs-section__block-second'
}

document.addEventListener("DOMContentLoaded", function () {
    const tabsSection = document.querySelector(selectors.tabsSection);
    if(tabsSection){
    const firstTabBtn = document.querySelector(selectors.firstTabBtn);
    const tabFirst = document.querySelector(selectors.tabFirst);
    const secondTabBtn = document.querySelector(selectors.secondTabBtn);
    const tabSecond = document.querySelector(selectors.tabSecond);

    function toggleTab(activeBtn, inactiveBtn, activeTab, inactiveTab) {
        if (activeBtn.classList.contains('active')) {
            activeBtn.classList.remove('active');
            activeTab.classList.add('tab-hidden');
        } else {
            inactiveBtn.classList.remove('active');
            inactiveTab.classList.add('tab-hidden');
            activeBtn.classList.add('active');
            activeTab.classList.remove('tab-hidden');
        }
    }
    
    firstTabBtn?.addEventListener('click', () => {
        toggleTab(firstTabBtn, secondTabBtn, tabFirst, tabSecond);
    });
    
    secondTabBtn?.addEventListener('click', () => {
        toggleTab(secondTabBtn, firstTabBtn, tabSecond, tabFirst);
    });
    

    let flktyInstances = [];
    function initializeSliders() {
        if (window.innerWidth < 1000 && flktyInstances.length === 0) {
            const tabsCarousel = tabsSection?.querySelectorAll(selectors.tabsCarousel);
            tabsCarousel.forEach((tab, index) => {
                const sliderBlock = tab.querySelector(selectors.blockSlider);
                const prevButton = tab.querySelector(selectors.prevButton);
                const nextButton = tab.querySelector(selectors.nextButton);
    
                if (sliderBlock) {
                    const flkty = new Flickity(sliderBlock, {
                        cellAlign: 'left',
                        contain: true,
                        prevNextButtons: false,
                        pageDots: false
                    });
    
                    
                    function updateButtonState() {
                        prevButton.disabled = flkty.selectedIndex === 0;
                        nextButton.disabled = flkty.selectedIndex === flkty.slides.length - 1;
                    }
    
                   
                    updateButtonState();
    
                    prevButton.addEventListener('click', function () {
                        flkty.previous();
                    });
    
                    nextButton.addEventListener('click', function () {
                        flkty.next();
                    });
    
                    flkty.on('change', updateButtonState);
                    flktyInstances[index] = flkty;
                }
            });
        }
    }
    

    function destroySliders() {
        if (window.innerWidth >= 1000 && flktyInstances.length > 0) {
            flktyInstances.forEach(flkty => {
                if (flkty) {
                    flkty.destroy();
                }
            });
            flktyInstances = [];
        }
    }

    initializeSliders();
    window.addEventListener('resize', function () {
        if (window.innerWidth < 1000) {
            initializeSliders();
        } else {
            destroySliders();
        }
    });
    }
});



